/* ==========================================================================
   kwmobile sale badge -- the discount figure
   --------------------------------------------------------------------------
   The badge markup ships with the translated word ("Sale") in it. This
   replaces that word with the real saving and wraps it so the stylesheet can
   rotate it onto the flag's diagonal.

   The figure is derived from the two prices the surface is ALREADY SHOWING,
   never from a Liquid snapshot and never from a hard-coded rate:
     - it cannot contradict the struck-through price beside it;
     - a promotion at a different rate needs no code change;
     - a swatch click rewrites the price, and the observer recomputes from it.

   Both prices are read from named elements rather than by scraping numbers out
   of the block. Scraping looked simpler but breaks on a price range or any
   second figure in the same node, which would silently produce a nonsense
   percentage.

   If a pair of prices cannot be read, the badge is hidden rather than left
   showing the bare word -- otherwise one grid can show "-20%" on some cards
   and "Sale" on others.
   ========================================================================== */
(function () {
  'use strict';

  var CARD = '.collection-product-card';
  var BOOST_CARD = '.boost-sd__product-item';
  var BOOST_BADGE = '.boost-sd__product-link-image span[style*="border-radius:50%"]';
  var MARK = 'kwSaleBadgeBound';

  /* Parse one money string. The German storefront prints 10,29 and the UK one
     7.09, so the decimal separator is decided by whichever of , or . comes
     last. */
  function money(text) {
    if (!text) return null;
    /* Strip whitespace first, then read the figure. JS \s already covers the
       non-breaking spaces Shopify puts inside thousands groups, so no unicode
       escapes are needed -- and an escape pasted in as a literal invisible
       character is a bug waiting to happen. Safe to flatten like this because
       each price is read from its own element, so there is only ever one
       figure in the string. */
    var raw = String(text).replace(/\s/g, '');
    var m = raw.match(/\d[\d.,]*\d|\d/);
    if (!m) return null;
    raw = m[0];
    var lastComma = raw.lastIndexOf(',');
    var lastDot = raw.lastIndexOf('.');
    var norm = lastComma > lastDot
      ? raw.replace(/\./g, '').replace(',', '.')
      : raw.replace(/,/g, '');
    var v = parseFloat(norm);
    return isFinite(v) && v > 0 ? v : null;
  }

  function label(wasEl, nowEl) {
    var was = money(wasEl && wasEl.textContent);
    var now = money(nowEl && nowEl.textContent);
    if (was === null || now === null || was <= now) return null;
    var pct = Math.round((1 - now / was) * 100);
    if (pct < 1 || pct > 99) return null;
    return '−' + pct + '%';
  }

  /* Replace the badge's contents with the figure in a wrapper the stylesheet
     can rotate. Hidden, not left as "Sale", when there is nothing to show. */
  function paint(badge, text) {
    if (!badge) return;
    if (!text) {
      badge.style.visibility = 'hidden';
      return;
    }
    badge.style.visibility = '';
    if (badge.getAttribute('data-kw-off') === text) return;
    badge.setAttribute('data-kw-off', text);
    var i = document.createElement('i');
    i.className = 'kw-off';
    i.textContent = text;
    badge.textContent = '';
    badge.appendChild(i);
  }

  function updateCard(card) {
    paint(
      card.querySelector('.collection-product-card__badge--sale'),
      label(
        card.querySelector('.collection-product-card__price-compare'),
        card.querySelector('.collection-product-card__price-current')
      )
    );
  }

  /* Boost redraws collection and search grids client-side, replacing the
     theme's cards entirely. Its badge template prints a hard-coded "-20%", so
     the figure is recomputed here -- otherwise the next promotion at a
     different rate would show the wrong saving on every collection page. */
  function updateBoostCard(card) {
    paint(
      card.querySelector(BOOST_BADGE),
      label(
        card.querySelector('.boost-sd__format-currency--price-compare'),
        card.querySelector('.boost-sd__product-price--sale')
      )
    );
  }

  function updatePdp() {
    var flag = document.querySelector('.kw-pdp-sale-flag');
    if (!flag) return;
    var sale = document.querySelector('.product .price--on-sale .price__sale');
    if (!sale) {
      paint(flag, null);
      return;
    }
    paint(flag, label(
      sale.querySelector('.price-item--regular'),
      sale.querySelector('.price-item--sale')
    ));
  }

  /* The theme rewrites prices in place on every swatch click, so watch the
     price node rather than listening for an event the theme may not fire. */
  function bind(el, onChange) {
    if (!el || el.dataset[MARK]) return;
    el.dataset[MARK] = '1';
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(onChange, 60);
    }).observe(el, { childList: true, characterData: true, subtree: true });
  }

  function scan() {
    var cards = document.querySelectorAll(CARD);
    for (var i = 0; i < cards.length; i++) {
      (function (card) {
        updateCard(card);
        bind(card.querySelector('.collection-product-card__price'), function () {
          updateCard(card);
        });
      })(cards[i]);
    }
    var boost = document.querySelectorAll(BOOST_CARD);
    for (var j = 0; j < boost.length; j++) updateBoostCard(boost[j]);
    updatePdp();
    bind(document.querySelector('.product__info-container'), updatePdp);
  }

  function start() {
    scan();
    /* Sliders, Boost and lazy sections add cards after first paint. */
    var timer = null;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes && records[i].addedNodes.length) {
          clearTimeout(timer);
          timer = setTimeout(scan, 200);
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
